module.exports = __webpack_public_path__ + "static/media/3-star.0f4e8c83.png";